import { linearTiming } from "@remotion/transitions";
import { TransitionKind, TransitionSpeed } from "@repo/api/transition";
import { msToFrames } from "../../utils/timing.ts";
import {
  getDefaultPreviewClipDurationsInFrames,
  ImageTransitionBuilder,
  ImageTransitionBuilderProps,
} from "./ImageTransitionBuilder.ts";
import { zoomBlur, ZoomBlurProps } from "../remocn/zoom-blur.tsx";

const transitionKind = TransitionKind.enum.ZOOM_BLUR;

const ZOOM_BLUR_DURATION_MS: Record<TransitionSpeed, number> = {
  SLOW: 1000,
  NORMAL: 600,
  FAST: 400,
};

function getZoomBlurDurationInFrames(props: ImageTransitionBuilderProps) {
  return msToFrames(
    ZOOM_BLUR_DURATION_MS[props.imageTransition.speed ?? "NORMAL"],
    props.fps,
  );
}

export const ImageZoomBlurTransitionBuilder: ImageTransitionBuilder<ZoomBlurProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getZoomBlurDurationInFrames,
      buildPresentation: () => zoomBlur(),
      buildTiming: (props) =>
        linearTiming({ durationInFrames: getZoomBlurDurationInFrames(props) }),
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
